import { PRIVACY_FLAT_BY_CODE } from './onboardingPrivacyCopy';

/** Flat i18n overrides for signup flow (locales that otherwise fall back to English). */

function mergeFlat(...parts) {
  return Object.assign({}, ...parts);
}

function flatSections({ auth = {}, onboarding = {}, interest = {}, common = {}, mypage = {}, privacy = {} }) {
  const out = {};
  const add = (prefix, obj) => {
    for (const [k, v] of Object.entries(obj)) {
      if (typeof v === 'string') out[`${prefix}.${k}`] = v;
    }
  };
  add('auth', auth);
  add('onboarding', onboarding);
  add('interest', interest);
  add('common', common);
  add('mypage', mypage);
  add('privacy', privacy);
  return out;
}

const JA = flatSections({
  auth: {
    tagline: '外国人・旅行者のためのプラットフォーム',
    tabLogin: 'ログイン',
    tabSignup: '新規登録',
    email: 'メール',
    password: 'パスワード',
    passwordConfirm: 'パスワード確認',
    nickname: 'ニックネーム',
    login: 'ログイン',
    signupSubmit: 'アカウント作成',
    browse: 'アカウントなしで閲覧',
    googleContinue: 'Googleで続ける',
    appleContinue: 'Appleで続ける',
    placeholderEmail: 'email@example.com',
    placeholderPassword: 'パスワード',
    placeholderPasswordConfirm: 'パスワードを再入力',
    placeholderNickname: 'ニックネーム',
    referralOptional: '紹介コード（任意）',
    referralPlaceholder: '例: MG-A3K9',
    agreePrivacy: 'プライバシーポリシーに同意（必須）',
    agreeMarketing: 'マーケティング情報の受信に同意（任意）',
    agreeLocation: '位置情報機能に同意（任意）',
    agreeAge14: '14歳以上です（必須）',
    needLegalConsents: 'プライバシーポリシーへの同意と14歳以上の確認が必要です。',
  },
  onboarding: {
    selectType: 'あなたはどちらですか？',
    typeExpat: '駐在員',
    typeExpatDesc: '海外在住の\n韓国人',
    typeTourist: '旅行者',
    typeTouristDesc: '旅行中または\n旅行予定',
    typeNomad: 'デジタルノマド',
    typeNomadDesc: '移動しながら\n働く',
    typeBusiness: 'ビジネス',
    typeBusinessDesc: '事業・出張\n目的',
    selectInterests: '興味のある分野を選んでください',
    selectInterestsDesc: 'あなたに合った情報をお届けします',
    next: '次へ',
    done: '完了',
    countryLabel: '国',
    locationSelectTitle: '都市を選択',
    cityHint: '都市は最大2つまで',
  },
  interest: {
    food: 'グルメ',
    golf: 'ゴルフ',
    realestate: '不動産',
    medical: '医療',
    education: '教育',
    shopping: 'ショッピング',
    sports: 'スポーツ',
    culture: '文化',
    finance: '金融',
    parenting: '子育て',
    beauty: 'ビューティー',
    travel: '旅行',
  },
  common: { back: '戻る', preparing: '準備中…' },
  mypage: { privacy: 'プライバシー' },
});

const TH = flatSections({
  auth: {
    tagline: 'สำหรับชาวต่างชาติและนักท่องเที่ยว',
    tabLogin: 'เข้าสู่ระบบ',
    tabSignup: 'สมัครสมาชิก',
    email: 'อีเมล',
    password: 'รหัสผ่าน',
    passwordConfirm: 'ยืนยันรหัสผ่าน',
    nickname: 'ชื่อเล่น',
    login: 'เข้าสู่ระบบ',
    signupSubmit: 'สร้างบัญชี',
    browse: 'เรียกดูโดยไม่มีบัญชี',
    googleContinue: 'ดำเนินการต่อด้วย Google',
    appleContinue: 'ดำเนินการต่อด้วย Apple',
    placeholderEmail: 'email@example.com',
    placeholderPassword: 'รหัสผ่าน',
    placeholderPasswordConfirm: 'ใส่รหัสผ่านอีกครั้ง',
    placeholderNickname: 'ชื่อเล่น',
    referralOptional: 'รหัสแนะนำ (ไม่บังคับ)',
    referralPlaceholder: 'เช่น MG-A3K9',
    agreePrivacy: 'ยอมรับนโยบายความเป็นส่วนตัว (จำเป็น)',
    agreeMarketing: 'ยอมรับการรับข้อมูลการตลาด (ไม่บังคับ)',
    agreeLocation: 'ยอมรับฟีเจอร์ตำแหน่ง (ไม่บังคับ)',
    agreeAge14: 'อายุ 14 ปีขึ้นไป (จำเป็น)',
    needLegalConsents: 'กรุณายอมรับนโยบายความเป็นส่วนตัวและยืนยันอายุ 14 ปีขึ้นไป',
  },
  onboarding: {
    selectType: 'คุณเป็นใคร?',
    typeExpat: 'ชาวต่างชาติ',
    typeExpatDesc: 'อาศัยอยู่\nต่างประเทศ',
    typeTourist: 'นักท่องเที่ยว',
    typeTouristDesc: 'กำลังเดินทาง\nหรือวางแผน',
    typeNomad: 'โนแมดดิจิทัล',
    typeNomadDesc: 'ทำงาน\nขณะเดินทาง',
    typeBusiness: 'ธุรกิจ',
    typeBusinessDesc: 'ธุรกิจ\nหรือทำงาน',
    selectInterests: 'เลือกความสนใจ',
    selectInterestsDesc: 'เราจะแนะนำข้อมูลที่เหมาะกับคุณ',
    next: 'ถัดไป',
    done: 'เสร็จสิ้น',
    countryLabel: 'ประเทศ',
    locationSelectTitle: 'เลือกเมือง',
    cityHint: 'เลือกได้สูงสุด 2 เมือง',
  },
  interest: {
    food: 'อาหาร',
    golf: 'กอล์ฟ',
    realestate: 'อสังหาริมทรัพย์',
    medical: 'การแพทย์',
    education: 'การศึกษา',
    shopping: 'ช้อปปิ้ง',
    sports: 'กีฬา',
    culture: 'วัฒนธรรม',
    finance: 'การเงิน',
    parenting: 'เลี้ยงลูก',
    beauty: 'ความงาม',
    travel: 'ท่องเที่ยว',
  },
  common: { back: 'กลับ', preparing: 'กำลังเตรียม…' },
  mypage: { privacy: 'ความเป็นส่วนตัว' },
});

const ID = flatSections({
  auth: {
    tagline: 'Untuk ekspat & wisatawan',
    tabLogin: 'Masuk',
    tabSignup: 'Daftar',
    email: 'Email',
    password: 'Kata sandi',
    passwordConfirm: 'Konfirmasi kata sandi',
    nickname: 'Nama panggilan',
    login: 'Masuk',
    signupSubmit: 'Buat akun',
    browse: 'Jelajahi tanpa akun',
    googleContinue: 'Lanjutkan dengan Google',
    appleContinue: 'Lanjutkan dengan Apple',
    placeholderEmail: 'email@example.com',
    placeholderPassword: 'Kata sandi',
    placeholderPasswordConfirm: 'Masukkan ulang kata sandi',
    placeholderNickname: 'Nama panggilan',
    referralOptional: 'Kode referral (opsional)',
    referralPlaceholder: 'mis. MG-A3K9',
    agreePrivacy: 'Saya setuju Kebijakan Privasi (wajib)',
    agreeMarketing: 'Saya setuju menerima info pemasaran (opsional)',
    agreeLocation: 'Saya setuju fitur lokasi (opsional)',
    agreeAge14: 'Saya berusia 14 tahun atau lebih (wajib)',
    needLegalConsents: 'Setujui Kebijakan Privasi dan konfirmasi usia 14+.',
  },
  onboarding: {
    selectType: 'Siapa Anda?',
    typeExpat: 'Ekspat',
    typeExpatDesc: 'Tinggal di\nluar negeri',
    typeTourist: 'Wisatawan',
    typeTouristDesc: 'Sedang atau\nakan bepergian',
    typeNomad: 'Nomad digital',
    typeNomadDesc: 'Bekerja sambil\nbepergian',
    typeBusiness: 'Bisnis',
    typeBusinessDesc: 'Bisnis atau\nperjalanan kerja',
    selectInterests: 'Pilih minat Anda',
    selectInterestsDesc: 'Kami tampilkan info yang relevan',
    next: 'Lanjut',
    done: 'Selesai',
    countryLabel: 'Negara',
    locationSelectTitle: 'Pilih kota',
    cityHint: 'Pilih hingga 2 kota',
  },
  interest: {
    food: 'Kuliner',
    golf: 'Golf',
    realestate: 'Properti',
    medical: 'Kesehatan',
    education: 'Pendidikan',
    shopping: 'Belanja',
    sports: 'Olahraga',
    culture: 'Budaya',
    finance: 'Keuangan',
    parenting: 'Pengasuhan',
    beauty: 'Kecantikan',
    travel: 'Perjalanan',
  },
  common: { back: 'Kembali', preparing: 'Menyiapkan…' },
  mypage: { privacy: 'Privasi' },
});

const HI = flatSections({
  auth: {
    tagline: 'प्रवासियों और यात्रियों के लिए',
    tabLogin: 'लॉग इन',
    tabSignup: 'साइन अप',
    email: 'ईमेल',
    password: 'पासवर्ड',
    passwordConfirm: 'पासवर्ड की पुष्टि',
    nickname: 'उपनाम',
    login: 'लॉग इन',
    signupSubmit: 'खाता बनाएं',
    browse: 'बिना खाते के देखें',
    googleContinue: 'Google से जारी रखें',
    appleContinue: 'Apple से जारी रखें',
    placeholderEmail: 'email@example.com',
    placeholderPassword: 'पासवर्ड',
    placeholderPasswordConfirm: 'पासवर्ड फिर दर्ज करें',
    placeholderNickname: 'उपनाम',
    referralOptional: 'रेफरल कोड (वैकल्पिक)',
    referralPlaceholder: 'उदा. MG-A3K9',
    agreePrivacy: 'मैं गोपनीयता नीति से सहमत हूँ (आवश्यक)',
    agreeMarketing: 'मैं मार्केटिंग जानकारी स्वीकार करता/करती हूँ (वैकल्पिक)',
    agreeLocation: 'मैं लोकेशन सुविधाओं से सहमत हूँ (वैकल्पिक)',
    agreeAge14: 'मेरी आयु 14 वर्ष या अधिक है (आवश्यक)',
    needLegalConsents: 'कृपया गोपनीयता नीति स्वीकार करें और 14+ की पुष्टि करें।',
  },
  onboarding: {
    selectType: 'आप कौन हैं?',
    typeExpat: 'प्रवासी',
    typeExpatDesc: 'विदेश में\nरहते हैं',
    typeTourist: 'यात्री',
    typeTouristDesc: 'यात्रा में\nया योजना',
    typeNomad: 'डिजिटल नोमैड',
    typeNomadDesc: 'यात्रा करते\nकाम',
    typeBusiness: 'व्यवसाय',
    typeBusinessDesc: 'व्यवसाय या\nकार्य',
    selectInterests: 'रुचियाँ चुनें',
    selectInterestsDesc: 'हम आपके लिए सामग्री दिखाएंगे',
    next: 'आगे',
    done: 'पूर्ण',
    countryLabel: 'देश',
    locationSelectTitle: 'शहर चुनें',
    cityHint: 'अधिकतम 2 शहर',
  },
  interest: {
    food: 'खाना',
    golf: 'गोल्फ',
    realestate: 'रियल एस्टेट',
    medical: 'चिकित्सा',
    education: 'शिक्षा',
    shopping: 'खरीदारी',
    sports: 'खेल',
    culture: 'संस्कृति',
    finance: 'वित्त',
    parenting: 'पालन-पोषण',
    beauty: 'सौंदर्य',
    travel: 'यात्रा',
  },
  common: { back: 'वापस', preparing: 'तैयार हो रहा है…' },
  mypage: { privacy: 'गोपनीयता' },
});

const ZH_CN = flatSections({
  auth: {
    tagline: '为侨民与旅行者打造',
    tabLogin: '登录',
    tabSignup: '注册',
    email: '邮箱',
    password: '密码',
    passwordConfirm: '确认密码',
    nickname: '昵称',
    login: '登录',
    signupSubmit: '创建账户',
    browse: '免账号浏览',
    googleContinue: '使用 Google 继续',
    appleContinue: '使用 Apple 继续',
    placeholderEmail: 'email@example.com',
    placeholderPassword: '密码',
    placeholderPasswordConfirm: '再次输入密码',
    placeholderNickname: '昵称',
    referralOptional: '推荐码（可选）',
    referralPlaceholder: '例如 MG-A3K9',
    agreePrivacy: '同意隐私政策（必填）',
    agreeMarketing: '同意接收营销信息（可选）',
    agreeLocation: '同意位置相关功能（可选）',
    agreeAge14: '我已满14周岁（必填）',
    needLegalConsents: '请同意隐私政策并确认年满14周岁。',
  },
  onboarding: {
    selectType: '您是？',
    typeExpat: '侨民',
    typeExpatDesc: '居住在\n海外',
    typeTourist: '旅行者',
    typeTouristDesc: '正在或计划\n旅行',
    typeNomad: '数字游民',
    typeNomadDesc: '边旅行\n边工作',
    typeBusiness: '商务',
    typeBusinessDesc: '商务或\n工作出行',
    selectInterests: '请选择兴趣',
    selectInterestsDesc: '我们将展示个性化内容',
    next: '下一步',
    done: '完成',
    countryLabel: '国家',
    locationSelectTitle: '选择城市',
    cityHint: '最多选择2个城市',
  },
  interest: {
    food: '美食',
    golf: '高尔夫',
    realestate: '房产',
    medical: '医疗',
    education: '教育',
    shopping: '购物',
    sports: '运动',
    culture: '文化',
    finance: '金融',
    parenting: '育儿',
    beauty: '美容',
    travel: '旅行',
  },
  common: { back: '返回', preparing: '准备中…' },
  mypage: { privacy: '隐私政策' },
});

const ZH_TW = flatSections({
  auth: {
    tagline: '為僑民與旅行者打造',
    tabLogin: '登入',
    tabSignup: '註冊',
    email: '電子郵件',
    password: '密碼',
    passwordConfirm: '確認密碼',
    nickname: '暱稱',
    login: '登入',
    signupSubmit: '建立帳戶',
    browse: '免帳號瀏覽',
    googleContinue: '使用 Google 繼續',
    appleContinue: '使用 Apple 繼續',
    placeholderEmail: 'email@example.com',
    placeholderPassword: '密碼',
    placeholderPasswordConfirm: '再次輸入密碼',
    placeholderNickname: '暱稱',
    referralOptional: '推薦碼（選填）',
    referralPlaceholder: '例如 MG-A3K9',
    agreePrivacy: '同意隱私權政策（必填）',
    agreeMarketing: '同意接收行銷資訊（選填）',
    agreeLocation: '同意位置相關功能（選填）',
    agreeAge14: '我已滿14歲（必填）',
    needLegalConsents: '請同意隱私權政策並確認年滿14歲。',
  },
  onboarding: {
    selectType: '您是？',
    typeExpat: '僑民',
    typeExpatDesc: '居住在\n海外',
    typeTourist: '旅行者',
    typeTouristDesc: '正在或計畫\n旅行',
    typeNomad: '數位遊牧',
    typeNomadDesc: '邊旅行\n邊工作',
    typeBusiness: '商務',
    typeBusinessDesc: '商務或\n工作出行',
    selectInterests: '請選擇興趣',
    selectInterestsDesc: '我們將顯示個人化內容',
    next: '下一步',
    done: '完成',
    countryLabel: '國家',
    locationSelectTitle: '選擇城市',
    cityHint: '最多選擇2個城市',
  },
  interest: {
    food: '美食',
    golf: '高爾夫',
    realestate: '房地產',
    medical: '醫療',
    education: '教育',
    shopping: '購物',
    sports: '運動',
    culture: '文化',
    finance: '金融',
    parenting: '育兒',
    beauty: '美容',
    travel: '旅行',
  },
  common: { back: '返回', preparing: '準備中…' },
  mypage: { privacy: '隱私權政策' },
});

export const ONBOARDING_FLOW_OVERRIDES = {
  ko: mergeFlat(PRIVACY_FLAT_BY_CODE.ko),
  en: mergeFlat(PRIVACY_FLAT_BY_CODE.en),
  vi: mergeFlat(PRIVACY_FLAT_BY_CODE.vi),
  ru: mergeFlat(PRIVACY_FLAT_BY_CODE.ru),
  ja: mergeFlat(JA, PRIVACY_FLAT_BY_CODE.ja),
  th: mergeFlat(TH, PRIVACY_FLAT_BY_CODE.th),
  id: mergeFlat(ID, PRIVACY_FLAT_BY_CODE.id),
  hi: mergeFlat(HI, PRIVACY_FLAT_BY_CODE.hi),
  'zh-CN': mergeFlat(ZH_CN, PRIVACY_FLAT_BY_CODE['zh-CN']),
  'zh-TW': mergeFlat(ZH_TW, PRIVACY_FLAT_BY_CODE['zh-TW']),
};
